import React, {Component} from 'react';
import './Modal.css'
import WindowDimensions from "../WindowDimensions";

class Modal extends Component {

    static defaultProps = {
        content: '',
        backgroundImage: 'none',
        height: null,
        width: null
    };

    constructor(props) {

        super(props);

        this.modalAreaRef = React.createRef();

        this.state = {
            modalHeight: 300,
            modalWidth: 200,
            modalTop: 0,
        };

        this.updateDimensions = this.updateDimensions.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.close = this.close.bind(this);

    };

    componentDidMount() {

        this.updateDimensions();

        window.addEventListener("resize", this.updateDimensions);

    }

    componentWillUnmount() {

        window.removeEventListener("resize", this.updateDimensions);

    }

    updateDimensions() {

        if (this.props.width === null || this.props.height === null) {
            let newWidth = this.modalAreaRef.current ? this.modalAreaRef.current.offsetWidth : 200;
            let newHeight = window.innerHeight - ((window.innerWidth > WindowDimensions.getMaxMobilWidth()) ? 200 : 120);

            if (newWidth < 200) newWidth = 200;
            if (newHeight < 200) newHeight = 200;

            let newTop = (window.innerHeight - newHeight) / 2;

            if (newTop < 0) newTop = 0;

            if (newWidth !== this.state.modalWidth || newHeight !== this.state.modalHeight || newTop !== this.state.modalTop) {
                this.setState({
                    modalHeight: newHeight,
                    modalWidth: newWidth,
                    modalTop: newTop,
                });
            }
        } else {
            let newTop = (window.innerHeight - this.props.height) / 2;

            if (newTop < 0) newTop = 0;

            this.setState({
                modalHeight: this.props.height,
                modalWidth: this.props.width,
                modalTop: newTop
            });
        }

    }

    handleKeyPress(event) {

        console.log('handleKeyPress event', event);

    };

    close() {

        if (this.props.onClose) this.props.onClose();

    }

    getBgImage() {

        if (this.props.backgroundImage === 'none') return this.props.backgroundImage;

        return (this.props.backgroundImage.includes("world")) ? this.props.backgroundImage : 'url(' + this.props.backgroundImage + ')';

    }

    render() {

        let content = this.props.content;
        let contentStyles = {
            width: this.state.modalWidth + 'px',
            height: this.state.modalHeight + 'px',
            backgroundImage: this.getBgImage()
        };

        return (
            <div ref={this.modalAreaRef}>
                <div className="modalContainer" style={{top: this.state.modalTop + 'px'}}>
                    <div className="modalBackground" onClick={this.close}>&nbsp;</div>

                    <div className="modalBox" style={contentStyles}>
                        <button className="modalClose" onClick={this.close}>x</button>

                        <div
                            className="modalContent"
                            onKeyPress={(event) => this.handleKeyPress(event)}>
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );

    }

}

export default Modal;